import { NavLinkConfig, NavLink } from '@/data/types/nav-link';
import { Search, MessageSquare, CreditCard, Home, BookOpen } from 'lucide-react';

export const IS_DEV = typeof window !== 'undefined' && window.location.hostname == 'localhost';

export const API_BASE_URL = IS_DEV
  ? 'http://localhost:4500'
  : 'https://api.agentcouncil.org';

// Aspis backend-v2 (vault metadata) — the /api/b2b/admin org-vault views live there, not
// on the AgentCouncil backend. Same admin bearer works: backend-v2 introspects it against
// this provider and checks the live is_super_admin flag.
export const ASPIS_BACKEND_API_URL = IS_DEV
  ? 'http://localhost:3001/api'
  : 'https://v2api-new.aspis.finance/api';

export const MAX_FREE_MESSAGES_PER_DAY = 5;

export const NAV_LINKS: NavLinkConfig = {
  lending: {
    href: 'https://agentcouncil.org',
    title: 'Home',
    icon: Home,
    emoji: '🌐',
    isExternal: true,
  },
  portfolioAnalysis: {
    href: '/',
    title: 'Portfolio Analysis',
    icon: Search,
    emoji: '🔍',
  },
  chat: {
    href: '/chat',
    title: 'AI Chat',
    icon: MessageSquare,
    emoji: '💬',
  },
  pricing: {
    href: '/pricing',
    title: 'Pricing',
    icon: CreditCard,
    emoji: '💳',
  },
  docs: {
    href: 'https://docs.agentcouncil.org/',
    title: 'Docs',
    icon: BookOpen,
    emoji: '📚',
    isExternal: true,
  },
} as const;

export const NAV_LINKS_ARRAY = Object.values(NAV_LINKS) as NavLink[];
